<div class="back">
    <div id="wrapper">
        <div class="join"><span class="blue">i</span>FIX <span class="ash" size="10">Account</span></div>
        <div class="lock"></div>

        <div class="clr">

            <div class="ash" size="3">Manage Your Customer Experience in Realtime</div>
        </div>
        <br>
        <p class="message">Verifying your details ......</p>
    </div>
</div>

